<template>
    <div>
        <div id="white-background"></div>
        <div id="dlgbox">
            <div id="dlg-header">You are logged out.</div>
            <div id="dlg-body">Please log in to continue.</div>
            <div id="dlg-footer">
                <button class="dlgBtnOk" @click="hideMessage"></button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['isShow'],
        watch: {
            isShow: function(newValue) {
                if (newValue) {
                    this.showMessage();
                } else {
                    this.hideMessage();
                }
            }
        },

        mounted: function() {
        },

        methods: {
            showMessage: function() {
                var whitebg = $("#white-background");
                var dlg = $("#dlgbox");

                whitebg.css('display', 'block');
                dlg.css('display', 'block');

                var winWidth = window.innerWidth;
                var winHeight = window.innerHeight;

                dlg.css('left', (winWidth / 2) - 300 / 2 + "px")
                dlg.css('top', "150px");
            },

            hideMessage: function() {

                var whitebg = $("#white-background");
                var dlg = $("#dlgbox");

                whitebg.css('display', 'none');
                dlg.css('display', 'none');
                location.reload();
            }
        }
    }
</script>